import React, { useState, useEffect } from "react";
import { fetchProducts } from "../services/shopifyService";
import "../App.css";

const Product = ({ set, shop, onStoreData, data }) => {
  const [products, setProducts] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [selectedProductIds, setSelectedProductIds] = useState(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchProducts(shop, keyword);
        setProducts(response.products);
        console.log("Data retrieved successfully1:", response.products);
      } catch (error) {
        console.error("Error retrieving data:", error);
      }
    };

    fetchData();
  }, [shop, keyword]);

  useEffect(() => {
    console.log("Raw data received:", data);
    try {
      if (data) {
        console.log("Raw data received:", data);
        // Check if data is a string
        if (typeof data === "string") {
          const firstParse = JSON.parse(data); // First parse
          console.log("First Parse:", firstParse);

          const parsedData = Array.isArray(firstParse)
            ? firstParse
            : JSON.parse(firstParse); // Second parse if needed
          console.log("Parsed Data:", parsedData);
          console.log("Type of Parsed Data:", typeof parsedData);

          if (Array.isArray(parsedData)) {
            console.log("Selected Products from Data:", parsedData);
            const productIdsSet = new Set(parsedData.map((id) => String(id)));
            console.log("Product IDs Set created:", productIdsSet);
            setSelectedProductIds(productIdsSet);
          } else {
            console.warn("Parsed data is not an array, it is:", parsedData);
            setSelectedProductIds(new Set());
          }
        } else {
          console.warn("Data is not a string:", data);
          setSelectedProductIds(new Set());
        }
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
      setSelectedProductIds(new Set());
    }
  }, [data]);

  const handleInputChange = (value) => {
    setKeyword(value);
  };

  const handleCheckboxChange = (id) => {
    setSelectedProductIds((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(String(id))) {
        newSelected.delete(String(id));
      } else {
        newSelected.add(String(id));
      }
      console.log("Checkbox changed, newSelected:", newSelected);
      return newSelected;
    });
  };

  const handleStoreData = () => {
    setLoading(true);

    const selectedProductIdsArray = Array.from(selectedProductIds);
    console.log("Selected product IDs to store:", selectedProductIdsArray);

    const jsonPayload = JSON.stringify(selectedProductIdsArray);

    if (onStoreData) {
      onStoreData(jsonPayload);
    }

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  return (
    <div className="modal-container">
      <div className="modal-middle">
        <div className="modal-header">
          <h4>Add Products</h4>
          <button onClick={() => set(false)}>X</button>
        </div>
        <div className="search-container">
          <input
            type="search"
            name="keyword"
            onChange={(e) => handleInputChange(e.target.value)}
            placeholder="Search products"
          />
        </div>
        <div className="product-list">
          {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="search-row">
                <input
                  type="checkbox"
                  id={product.id}
                  checked={selectedProductIds.has(String(product.id))}
                  onChange={() => handleCheckboxChange(String(product.id))}
                />
                <label htmlFor={product.id}>{product.title}</label>
               
              </div>
            ))
          ) : (
            <p>No products found</p>
          )}
        </div>
        {loading && <div className="loading">Loading...</div>}
        <div className="modal-footer">
          <button onClick={handleStoreData} disabled={loading}>
            Store Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default Product;
